import { TableBadgeLabel } from '@components'

import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useContacts } from '../../../../../../hooks/useContacts'
import { useContactType } from '../../../../contexts/contactTypeContext'

export const ContactsTitle = ({ title }: { title: string }): ReactElement => {
  const { t } = useTranslation()
  const { isCustomer, isSupplier } = useContactType()
  const { isLoading, pagination } = useContacts({ isCustomer, isSupplier })

  return (
    <TableBadgeLabel amount={pagination?.total} isLoading={isLoading} color="neutral">
      {title || t('contacts.header')}
    </TableBadgeLabel>
  )
}
